// calcBanners()
$(document).ready(function () {
    setTimeout(() => calcBanners(), 100)
})
$(window).resize(() => calcBanners())

function calcBanners() {
    if(!device.mobile() || !device.tablet()) {
        $(".banner-action").each(function () {
            let height = $(this).innerHeight();

            let offset = 100
            // console.log(height)
            $(this).find(".round").css({
                'height': height+offset,
                'width': height+offset,
                // 'right': 'calc(-50% + 30px)',
            })

            let textWidth = height + offset
            $(this).find(".banner-action-content").css({
                'width': 'calc(100%)',
            })


            let bannerContentHeight = $(this).find(".banner-action-content").innerHeight();
            $(this).find(".action-button").css({
                'height': bannerContentHeight,
            })
        })
    }
}
